import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import CardItemsTable from "./_cartItems_table";
import { Helmet } from "react-helmet";

import translate from "../../../shared/utils/translations";
import {
  downloadAsinListExcelWithCustomColumns,
  requestHandler,
} from "../../../shared/utils/helpers";

const CartItems = ({ setPage }) => {
  useEffect(() => {
    setPage("dashboard-client");
    localStorage.setItem("dashboard-type", "dashboard-client");
  });
  const [cartItems, setCartItems] = useState([]);
  const [buffer, setBuffer] = useState([]);

  const getCartItems = async () => {
    const cartItems = await requestHandler(
      "get",
      "/cartItems",
      null,
      true,
      null,
      null
    ).then((res) => {
      if (res.error) {
        toast.error(res.error);
        return [];
      }
      console.log("res", res?.data);
      setCartItems(res?.data);
      setBuffer(res?.data);
    });
  };

  const removeCartItem = async (id) => {
    await requestHandler("delete", `/cartItems/${id}`, true, null, null).then(
      (res) => {
        if (res.error) {
          toast.error(res.error);
          return [];
        }
        console.log("res", res?.data);
        getCartItems();
      }
    );
  };

  useEffect(() => {
    getCartItems();
  }, []);

  const [isItem, setItem] = useState("Custom item #1");
  return (
    <>
      <Helmet>
        <title>{translate("Add Cart Items")}</title>
      </Helmet>
      <div className="outer__inner">
        <div className="onex_wl bg_white">
          <div className="onex_wl__wrapper">
            <div className="upload__head fvvbg">
              <div className="lftt__ibbn">
                <h2 className="upload__title h2">
                  {translate("Add Cart Items")}
                </h2>

                <div className="keys__info">
                  {translate(
                    "You can see all the products you have added to the cart with the plugin here."
                  )}
                </div>
              </div>
            </div>
            <div className="onex_wl__list">
              <div className="keys__enabled d_block">
                <div className="keys__list">
                  <div className="keys__item ss ggjk">
                    <CardItemsTable
                      data={buffer}
                      removeCartItem={removeCartItem}
                      refreshData={getCartItems}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartItems;
